import React from 'react';
import PropTypes from 'prop-types';
import cls from 'classname';

export const DashboardMobile = ({
  width,
  height,
  className,
  fill,
  outline,
  theme,
}) =>
  outline ? (
    <svg
      width={26}
      height={26}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 58 58"
      className={cls(className, 'icon icon-home icon-home-outline')}
      fill='#6e7daf'
    >
      <g id="Layer_38" data-name="Layer 38">
          <path d="M53.09,30.82A1.5,1.5,0,0,0,53,28.73l-4.3-3.85h0L33,10.88a1.5,1.5,0,0,0-2,0l-15.66,14h0L11,28.73a1.59,1.59,0,0,0-.49,1,1.52,1.52,0,0,0,1.19,1.59c0,.05,3,0,3.1,0V52a1.5,1.5,0,0,0,1.5,1.5H26.45A1.5,1.5,0,0,0,28,52V39.56h8.1V52a1.5,1.5,0,0,0,1.5,1.5H47.66a1.5,1.5,0,0,0,1.5-1.5V31.35H52A1.48,1.48,0,0,0,53.09,30.82Zm-14,19.68V38.06a1.5,1.5,0,0,0-1.5-1.5H26.45a1.5,1.5,0,0,0-1.5,1.5V50.5H17.84V29.85A1.57,1.57,0,0,0,16,28.35l1.38-1.23h0L32,14,46.66,27.12h0L48,28.35a1.58,1.58,0,0,0-1.88,1.51V50.5Z"/>
      </g>
    </svg>
  ) : (
    <svg
      width={26}
      height={26}
      fill={'#237cfb'}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 58 58"
      className={cls(className, 'icon icon-home icon-home-bold')}
    >
      <g id="Layer_38" data-name="Layer 38">
      <path d="M53.45,29.79A1.51,1.51,0,0,0,53,28.73l-4.3-3.85h0L33,10.88a1.5,1.5,0,0,0-2,0l-15.66,14h0L11,28.73a1.54,1.54,0,0,0-.49,1,1.52,1.52,0,0,0,1.19,1.59c0,.05,3,0,3.1,0V52a1.5,1.5,0,0,0,1.5,1.5H26.45A1.5,1.5,0,0,0,28,52V39.56h8.1V52a1.5,1.5,0,0,0,1.5,1.5H47.66a1.5,1.5,0,0,0,1.5-1.5V31.35c.14,0,3.09,0,3.1,0A1.51,1.51,0,0,0,53.45,29.79Z"/>
      </g>
    </svg>
  );

DashboardMobile.defaultProps = {
  width: 24,
  height: 24,
  // fill: '#6E7DAE',
  outline: true,
};

DashboardMobile.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string,
  fill: PropTypes.string,
  outline: PropTypes.bool,
};

export default DashboardMobile;
